import { z } from 'zod';
import { Channel } from './channel';

export const channelFormSchema = z
  .object({
    channel: z.enum(['loja_fisica', 'loja_online']),
    branchId: z.string(),
    themeId: z.string().min(1, 'Selecione um tema'),
  })
  .refine((data) => data.channel === 'loja_online' || data.branchId !== '', {
    message: 'Selecione a loja',
    path: ['branchId'],
  });

/** `channel` aceita string vazia para representar "nenhum canal escolhido ainda" — o schema acima rejeita esse estado, o que mantém `isValid` false até o usuário escolher um card. */
export type ChannelFormValues = {
  channel: Channel | '';
  branchId: string;
  themeId: string;
};
